import { uniq } from 'lodash';
import { useCallback, useMemo } from 'react';
import { hasDisplayCategory } from '../../../../../../../data/filters/schedule/hasDisplayCategory';
import { useEventSchedule } from '../../../../../../../data/hooks/schedule/useEventSchedule';

/**
 * Returns an array of objects each with a category and an items array.
 * Categories are all unique display categories of the given event's sessions
 * that are in the given date filter range. Items are the sessions that belong
 * to their respective categories.
 *
 * @param {string} eventId - The ID of the event from which to fetch the schedule.
 * @param {function} dateFilter - A function that takes a session object and returns true if the session is in the desired date range or false otherwise.
 */
export function useTodayCategories(eventId, dateFilter) {
    const filter = useCallback((item) => dateFilter(item) && hasDisplayCategory(item), [dateFilter]),
        schedule = useEventSchedule(eventId, {
            filter,
        });

    return useMemo(() => {
        const categories = uniq(schedule.map((item) => item.display_category)).map((category) => ({
            category,
            items: schedule.filter((session) => session.display_category == category),
        }));
        return categories;
    }, [schedule]);
}
